import DiagramOne from "../../../../src/data/articles/cube-power-level-a-users-guide/rudimentary-mtg-cube-power-level.png";
import DiagramTwo from "../../../../src/data/articles/cube-power-level-a-users-guide/complete-mtg-cube-power-level.png";
import DiagramThree from "../../../../src/data/articles/cube-power-level-a-users-guide/specific-mtg-cube-power-level.png";
import * as React from 'react';
export default {
  DiagramOne,
  DiagramTwo,
  DiagramThree,
  React
};